import { api } from '../../../lib/api';
import type { ListQuery, PagedResult } from '../../administration/users/userTypes';
import { filesAt, listParams } from './casesApi';
import type { PostOperationReportListItem, PostOperationReportRequest } from './caseTypes';

/**
 * A case's Post Operation Reports. The case is on the ROUTE of the list and the create — never in
 * the body — and every other call names the report.
 */
export const postOperationReportsApi = {
  list: (caseId: string, query: ListQuery, signal?: AbortSignal) =>
    api<PagedResult<PostOperationReportListItem>>(`/api/cases/${caseId}/post-operation-reports${listParams(query)}`, { signal }),

  create: (caseId: string, request: PostOperationReportRequest) =>
    api<PostOperationReportListItem>(`/api/cases/${caseId}/post-operation-reports`, { method: 'POST', body: request }),

  get: (id: string, signal?: AbortSignal) => api<PostOperationReportListItem>(`/api/post-operation-reports/${id}`, { signal }),

  update: (id: string, request: PostOperationReportRequest) =>
    api<PostOperationReportListItem>(`/api/post-operation-reports/${id}`, { method: 'PUT', body: request }),

  deactivate: (id: string) => api<void>(`/api/post-operation-reports/${id}`, { method: 'DELETE' }),

  activate: (id: string) => api<void>(`/api/post-operation-reports/${id}/restore`, { method: 'POST' }),

  /** `post-operation-reports.read` lists, `.attach` writes, `.download` reads the bytes. */
  files: (id: string) => filesAt(`/api/post-operation-reports/${id}/attachments`),
};
